import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { finalize, Observable } from 'rxjs';
import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';

// Functional interceptor for Loader
export const loaderInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const loaderService = inject(LoaderService);

  loaderService.show();  // Show loader

  return next(req).pipe(
    finalize(() => loaderService.hide())  // Hide loader after request is completed
  );
};
